// extracted by mini-css-extract-plugin
module.exports = {"icon":"ErrorBoundary_icon__6d06j"};